import { IonLabel } from '@ionic/react';
import { CareerEntryItem, type CareerEntryItemEntry } from './CareerEntryItem';

interface PublicCareerHistorySectionProps {
  entries: CareerEntryItemEntry[];
  overlapsPathPrefix?: string;
}

// Read-only "Historial" block of another user's public profile.
export const PublicCareerHistorySection = ({
  entries,
  overlapsPathPrefix,
}: PublicCareerHistorySectionProps) => (
  <div className="mt-4">
    <IonLabel className="mb-2 block text-sm font-semibold uppercase tracking-wide text-gray-500">
      Historial
    </IonLabel>
    {entries.length === 0 ? (
      <div className="rounded-2xl border border-dashed border-[#cfd5df] bg-white p-5 text-center">
        <p className="m-0 text-sm text-slate-500">Todavía no ha añadido su trayectoria</p>
      </div>
    ) : (
      <div className="overflow-hidden rounded-2xl border border-[#e8ebf1] bg-white">
        {entries.map((entry) => (
          <CareerEntryItem
            key={entry.id}
            entry={entry}
            overlapsPathPrefix={overlapsPathPrefix}
          />
        ))}
      </div>
    )}
  </div>
);
